import { HugeiconsIcon } from "@hugeicons/react";
import { Share03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import Arcs from "../../assets/Arcs";
import Tile from "../../assets/Tile";

type Props = {
  href: string;
  label: string;
};

const Shortcut: FC<Props> = ({ href, label }) => (
  <Button
    variant="unstyled"
    asChild
    className="relative h-10 flex-1 justify-start gap-2 overflow-hidden rounded-xl border-t border-t-foreground/5 bg-card py-2 pr-3 pl-2 font-semibold text-foreground text-sm shadow-md"
  >
    <a href={href} data-slot="shortcut">
      <Arcs variant="card" />
      <Tile type="link" size="28" />
      <span className="flex-1">{label}</span>
      <HugeiconsIcon icon={Share03Icon} className="text-muted-foreground" />
    </a>
  </Button>
);

export default Shortcut;
